export default __webpack_public_path__ + "static/media/38.7b6bf7ef.png";